import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const LINK_CLASS =
  'inline-flex items-center gap-2 text-sm text-gray-600 hover:text-brand-600 shrink-0 transition-colors';

export interface BackToListLinkProps {
  /** 목록 페이지 경로 (있으면 Link, 없으면 button) */
  to?: string;
  /** to 없을 때 클릭 핸들러 */
  onClick?: () => void;
  /** 버튼/링크 텍스트 */
  children: React.ReactNode;
  /** 추가 className (예: mb-4) */
  className?: string;
}

/**
 * 상세 페이지 상단 "목록으로" 링크/버튼. 위치·스타일 통일용.
 */
export function BackToListLink({ to, onClick, children, className = '' }: BackToListLinkProps): React.ReactElement {
  const combined = `${LINK_CLASS} ${className}`.trim();
  if (to != null && to !== '') {
    return (
      <Link to={to} className={combined}>
        <ArrowLeft size={16} />
        {children}
      </Link>
    );
  }
  return (
    <button type="button" onClick={onClick} className={combined}>
      <ArrowLeft size={16} />
      {children}
    </button>
  );
}
